import * as React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Amplify } from 'aws-amplify';

import './i18n/i18n';
import { UIProvider } from './store/uiContext';
import { AuthProvider } from './store/authContext';
import VPTApp from './VPTApp';
import { UserProvider } from './store/userContext';
import { SiteProvider } from './store/siteContext';
import { StorageProvider } from './store/storageContext';
import { ProductProvider } from './store/productContext';
import { ContactProvider } from './store/contactContext';
import { ProductgroupProvider } from './store/productgroupContext';
import { ApplicationLinkProvider } from './store/applicationLinkContext';
import { ReportProvider } from './store/reportContext';
import { ReportViewProvider } from './store/reportViewContext';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_AWS_POOL_ID!,
      userPoolClientId: process.env.REACT_APP_AWS_CLIENT_ID!,
      loginWith: {
        email: true,
      }
    }
  }
});

const App: React.FC = () => {
  return (
    <Router>
      <UIProvider>
        <AuthProvider>
          <UserProvider>
            <SiteProvider>
              <StorageProvider>
                <ProductProvider>
                  <ApplicationLinkProvider>
                    <ContactProvider>
                      <ProductgroupProvider>
                        <ReportProvider>
                          <ReportViewProvider>
                            <VPTApp />
                          </ReportViewProvider>
                        </ReportProvider>
                      </ProductgroupProvider>
                    </ContactProvider>
                  </ApplicationLinkProvider>
                </ProductProvider>
              </StorageProvider>
            </SiteProvider>
          </UserProvider>
        </AuthProvider>
      </UIProvider>
    </Router>
  );
};

export default App;
